import { t } from "i18next";
import { Base } from "../../framework/common/base";
import { Dayjs } from "dayjs";
import { StrMeasureUnit } from "./enums";

export class AppUtils {

    // Result is in format 'Y h Z min' where Y is hours, Z is minutes and only units > 0 are included
    static getDurationStrByDurationMin(durationMin: number, showZeroDuration = false): string {
        if (durationMin <= 0 && !showZeroDuration) return "";
        if (durationMin <= 0 && showZeroDuration) return `${durationMin.toString(10)} ${t("time.abrMins")}`;
        const durationHour = durationMin >= 60 ? Math.floor(durationMin / 60) : 0;
        durationMin = Math.round(durationMin - 60 * durationHour);
        return (
            (durationHour > 0 ? `${durationHour.toString(10)} ${t("time.abrHours")} ` : "") +
            (durationMin > 0 ? `${durationMin.toString(10)} ${t("time.abrMins")}` : "")
        ).trim();
    }

    static getDurationStrByDurationMinShort(
        durationMin: number,
        showZeroDuration = false): string {
        let durationMinAbs = Math.abs(Math.round(durationMin));
        if (durationMinAbs <= 0 && !showZeroDuration) return "";
        const durationHour = durationMinAbs >= 60 ? Math.floor(durationMinAbs / 60) : 0;
        durationMinAbs = Math.round(durationMinAbs - 60 * durationHour);
        return (
            (durationMin < 0 ? "-" : "") +
            (durationHour.toString(10) + ":") +
            Base.leftPad(durationMinAbs.toString(10), 2, "0")
        ).trim();
    }

    static getDurationInHoursAndMinutes = (
        startTime: string | Date | number | Dayjs,
        endTime: string | Date | number | Dayjs
    ) => {
        const dayMinutes = Base.dateDiffInMinutes(startTime, endTime);
        const totalHours = AppUtils.getDurationStrByDurationMin(
            dayMinutes,
            true
        );
        return totalHours;
    };


    static getDurationFieldLabel = ({ measureUnitIsDays, measureUnitIsHours, measureUnitIsAmount }, isPartialDayBooking: boolean) => {
        let prefix = t("time.duration");
        let suffix = t("time.abrDays");
        if(isPartialDayBooking) suffix = t("time.abrHours");
        if(measureUnitIsDays && !isPartialDayBooking) suffix = t("time.abrDays");
        if(measureUnitIsHours) suffix = t("time.abrHours");
        if(measureUnitIsAmount) {
            prefix = t("amount.amount");
            suffix = t("amount.measureUnitPcs");
        }
        return `${prefix} (${suffix})`;
    };

    static getHourMeasureUnits = (): string[] => {
        return [
            StrMeasureUnit.Hour,
            StrMeasureUnit.HourFi,
        ];
    };
    static getAmountMeasureUnits = (): string[] => {
        return [
            StrMeasureUnit.Piece,
        ];
    };
    static getDayMeasureUnits = (): string[] => {
        return [
            StrMeasureUnit.Day, StrMeasureUnit.DayFiAlt, StrMeasureUnit.DayEn
        ];
    };

    static isTimeUnit = (unit: string): boolean => {
        return AppUtils.getHourMeasureUnits().includes(unit);
    };

    static getDisplayedNumberBasedOnUnit = (amount: number, unit: string, blankIfZero?: boolean): string => {
        if (blankIfZero && !amount) return "-";
        return AppUtils.isTimeUnit(unit)
            ? AppUtils.getDurationStrByDurationMin(amount, true)
            : `${amount} ${unit}`;
    };
}
